import React from 'react';
import * as S from './tool-tip.styles';

const ReviewBlock = ({ hotel }) => {
  if (!hotel) {
    return null;
  }

  return (
    <S.ReviewContainer className="flexCol width100">
      <S.ReviewSpc className="justifyBetween dF brdrBot">
        <S.ReviewHd>
          <S.ReviewPer>{`${hotel.reco_percent}%`}</S.ReviewPer> Guest recommend this hotel
        </S.ReviewHd>
        <div className="flexCol">
          <div className="dF alignItemsCenter">
            <S.Go className="f500 dF alignItemsCenter justifyCenter">go</S.Go>
            <span className="padL5">{hotel.go_rating}/5</span>
          </div>
          <div className="greyCnt padT5">{hotel.review_count} reviews</div>
        </div>
      </S.ReviewSpc>

      <S.ReviewSpc className="dF justifyBetween">
        {hotel.review && (
          <S.ReviewTxtWrp className="flex1 flexCol">
            <S.Reviewer>
              <span>{hotel.review.rn}</span>
              <span>{hotel.review.rts}</span>
            </S.Reviewer>
            <S.ReviewComment className="greyCnt">{hotel.review.rc}</S.ReviewComment>
          </S.ReviewTxtWrp>
        )}
        <S.ReviewRatingWrp className="flex1 flexCol">
          {hotel.gir_data &&
            Object.entries(hotel.gir_data).map(
              (hotel_data, index) =>
                hotel_data && (
                  <S.ListRating key={index} className="dF alignItemsCenter">
                    <div className="padR5 flex1">{hotel_data[0]}</div>
                    <div className="flex1">
                      <S.PrgrsRt>
                        <S.PrgrsWidth style={{ width: (hotel_data[1] * 8) / 10 }}></S.PrgrsWidth>
                      </S.PrgrsRt>
                    </div>
                  </S.ListRating>
                )
            )}
        </S.ReviewRatingWrp>
      </S.ReviewSpc>

      {hotel.review_tip && (
        <S.QuickTip className="flexCol">
          <div>Quick Tip</div>
          <S.TipText className="padT5 padB5">{hotel.review_tip.tip}</S.TipText>
          <div className="dF alignItemsCenter">
            <span>{`- ${hotel.review_tip.rn}`}</span>
            <S.GoRating className="dF">
              <S.GoRatingTxt>{hotel.review_tip.rr}</S.GoRatingTxt>/5
            </S.GoRating>
          </div>
        </S.QuickTip>
      )}
    </S.ReviewContainer>
  );
};
export default ReviewBlock;
